import { useIntl } from 'react-intl';

import { CheckboxInput } from 'Views/Components/New/CheckboxInput';
import { TextInput } from 'Views/Components/New/TextInput';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';
import { isVehicleBookingWizardData, VehicleBookingWizardData } from '../../BookingWizardData/VehicleBookingWizardData';
import { useBookingWizardDataStore } from '../../BookingWizardDataStore';
import { WizardErrors } from '../../BookingWizardTypes';

export function VehicleRegoInput() {
	const intl = useIntl();
	const { wizardData, setWizardData, innerWizardErrors, setInnerWizardErrors } = useBookingWizardDataStore();

	if (!isVehicleBookingWizardData(wizardData.innerWizardData)) {
		return <></>;
	}

	const typedErrors = innerWizardErrors as WizardErrors<VehicleBookingWizardData>;
	const { cargoIdentification, hiredVehicle } = wizardData.innerWizardData;

	return (
		<div className="flex flex-col gap-2">
			<TextInput
				className="vehicle-rego-input"
				id="vehicle-registration"
				label={intl.formatMessage({
					id: 'vehicle-tab__rego__label',
					defaultMessage: 'Rego',
				})}
				placeholder={intl.formatMessage({
					id: 'vehicle-tab__rego__placeholder',
					defaultMessage: 'Enter rego',
				})}
				required
				disabled={hiredVehicle}
				value={cargoIdentification ?? ''}
				onChange={e => {
					const newData = new BookingWizardData({ ...wizardData });
					if (isVehicleBookingWizardData(newData.innerWizardData)) {
						newData.innerWizardData.cargoIdentification = e.target.value;
					}
					setWizardData(newData);

					const newErrors = { ...typedErrors };
					delete newErrors.cargoIdentification;
					setInnerWizardErrors(newErrors);
				}}
				error={typedErrors?.cargoIdentification}
			/>
			<CheckboxInput
				id="hired-vehicle-checkbox"
				size="sm"
				label={intl.formatMessage({
					id: 'vehicle-tab__rego-checkbox__label',
					defaultMessage: "I am hiring a vehicle, or I don't know my details",
				})}
				checked={!!hiredVehicle}
				onChange={e => {
					const newData = new BookingWizardData({ ...wizardData });
					if (isVehicleBookingWizardData(newData.innerWizardData)) {
						newData.innerWizardData.hiredVehicle = e.target.checked;
						newData.innerWizardData.cargoIdentification = e.target.checked ? 'N/A' : '';
					}
					setWizardData(newData);

					const newErrors = { ...typedErrors };
					delete newErrors.cargoIdentification;
					setInnerWizardErrors(newErrors);
				}}
			/>
		</div>
	);
}
